"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _UserActivationStatus = _interopRequireDefault(require("./UserActivationStatus"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The UserFilter model module.
 * @module model/UserFilter
 * @version 1.1.3-alpha.1
 */
class UserFilter {
  /**
   * Constructs a new <code>UserFilter</code>.
   * @alias module:model/UserFilter
   */
  constructor() {
    UserFilter.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>UserFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserFilter} obj Optional instance to populate.
   * @return {module:model/UserFilter} The populated <code>UserFilter</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UserFilter();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('email')) {
        obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
      }
      if (data.hasOwnProperty('emailContains')) {
        obj['emailContains'] = _ApiClient.default.convertToType(data['emailContains'], 'String');
      }
      if (data.hasOwnProperty('activationStatus')) {
        obj['activationStatus'] = _UserActivationStatus.default.constructFromObject(data['activationStatus']);
      }
      if (data.hasOwnProperty('nonEndUser')) {
        obj['nonEndUser'] = _ApiClient.default.convertToType(data['nonEndUser'], 'Boolean');
      }
      if (data.hasOwnProperty('q')) {
        obj['q'] = _ApiClient.default.convertToType(data['q'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>UserFilter</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserFilter</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
      throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
    }
    // ensure the json data is a string
    if (data['emailContains'] && !(typeof data['emailContains'] === 'string' || data['emailContains'] instanceof String)) {
      throw new Error("Expected the field `emailContains` to be a primitive type in the JSON string but got " + data['emailContains']);
    }
    // ensure the json data is a string
    if (data['q'] && !(typeof data['q'] === 'string' || data['q'] instanceof String)) {
      throw new Error("Expected the field `q` to be a primitive type in the JSON string but got " + data['q']);
    }
    return true;
  }
}

/**
 * @member {String} id
 */
UserFilter.prototype['id'] = undefined;

/**
 * @member {String} email
 */
UserFilter.prototype['email'] = undefined;

/**
 * @member {String} emailContains
 */
UserFilter.prototype['emailContains'] = undefined;

/**
 * @member {module:model/UserActivationStatus} activationStatus
 */
UserFilter.prototype['activationStatus'] = undefined;

/**
 * @member {Boolean} nonEndUser
 */
UserFilter.prototype['nonEndUser'] = undefined;

/**
 * @member {String} q
 */
UserFilter.prototype['q'] = undefined;
var _default = exports.default = UserFilter;